module.exports = __webpack_public_path__ + "img/Kielland_En_sann_realist.6a199d70.jpg";